import { render, staticRenderFns } from "./NumberPlate.vue?vue&type=template&id=253297a6&scoped=true"
import script from "./NumberPlate.vue?vue&type=script&lang=js"
export * from "./NumberPlate.vue?vue&type=script&lang=js"
import style0 from "./NumberPlate.vue?vue&type=style&index=0&id=253297a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253297a6",
  null
  
)

export default component.exports